import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appPhoneFormat]'
})
export class PhoneFormatDirective {
    constructor(private el: ElementRef, private ngControl: NgControl) {}

    @HostListener('input', ['$event.target.value'])
    onInput(value: string): void {
        value = value.replace(/\D/g, '');

        let phoneNumber: string;
        if (value.length < 3) {
            phoneNumber = `+${value.slice(0)}-`;
        } else if (value.length <= 5) {
            phoneNumber = `+${value.slice(0, 2)}-${value.slice(2)}`;
        } else if (value.length <= 9) {
            phoneNumber = `+${value.slice(0, 2)}-${value.slice(2, 5)}-${value.slice(5)}`;
        } else {
            phoneNumber = `+${value.slice(0, 2)}-${value.slice(2, 5)}-${value.slice(5, 8)}-${value.slice(8)}`;
        }

        this.ngControl.control.setValue(phoneNumber, { emitEvent: false });
    }
}
